import{NATIVE_HANDLER_ID as t}from"../constants";export var isNativeHandler=function(r){return r.getId()===t};